import { useTaskStoreBase } from '../stores/taskStore';
import { useOpportunityStoreBase } from '../stores/opportunityStore';
import { useQuoteStoreBase } from '../stores/quoteStore';
import { useProjectStoreBase } from '../stores/projectStore';
import { usePaymentStoreBase } from '../stores/paymentStore';

/**
 * 封存／恢復客戶後，任務、商機、報價、專案、收款列表上的客戶封存狀態一起更新
 * （封存客戶的關聯資料不能編輯，列表要立即反映）；分頁快取清掉，下次進列表重新載入
 */
export const updateCustomerArchived = (customerIds: string[], archived: boolean) => {
  const ids = new Set(customerIds);
  [useTaskStoreBase, useOpportunityStoreBase, useQuoteStoreBase, useProjectStoreBase, usePaymentStoreBase].forEach(store => {
    store.setState((state: any) => ({
      items: state.items.map((item: any) =>
        item.customer && ids.has(item.customer.id) ? { ...item, customer: { ...item.customer, archived } } : item
      ),
    }));
    store.getState().clearCache();
  });
};
